import React from 'react';

const VeterinaryPage = () => {
  return (
    <div>
      <h1>Veterinary</h1>
    </div>
  );
};

export default VeterinaryPage;
